import { useSelector } from 'react-redux';
import React from 'react'

const useAuth = (props) => {
    let OCType = 'VA' 
    if(props && Object.keys(props).length > 0)
    {
        if(props.consecutiveIndex != '' && props.consecutiveIndex != null && props.consecutiveIndex != undefined)
        {
            let x =props.consecutiveIndex.replace(/[0-9]/g,'')
            OCType = x
        }
    }
    //Agregar o modificar endpoint que obtiene el detalle de la oc y obtener el tipo
    let isOCA  = false
    let isOCV = false
    let isOCVA = false
    let status = "VA"

    if(OCType){
        switch(OCType)
        {
            case 'A':
                isOCA = true;
                status = 'A'
                break;
            case 'V':
                isOCV = true;
                status = 'V'
                break;
            case 'VA':
                isOCVA = true;
                status = 'VA'
                break;
        }

        return { isOCA, isOCV, isOCVA, status }
    }

    return { isOCA, isOCV, isOCVA, status }
}

export default useAuth